<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <div id="reporting" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
          <div>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Sales & Property Tax </b>
              </span>
            </nav>
            <br>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-6 col-md-6  d-flex justify-content-lg-end align-items-center">
                <label class="col-form-label col-form-label-sm required">Zipcode</label>
              </div>
              <div class="col-6 col-md-6  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input @keypress="isNumber($event)" minlength="5" maxlength="6" type="text" v-validate="'required'"
                  name="Zipcode" data-vv-as="Zipcode" class="form-control input-sm" v-model="propertyTax.zipcode"
                  placeholder="Enter Zipcode">
                <div v-if="errors.has('Zipcode')" class="alert-danger"> {{ errors.first('Zipcode') }} </div>
              </div>

              <div class="col justify-content-end align-items-center ">
                <button class="btn btn-secondary" @click="onSubmit">Search</button>
                &nbsp;&nbsp;
                <button v-if="isSearch" class="btn btn-secondary" @click="onReset">Reset</button>
              </div>
            </div>
            <div>
              <div class="col justify-content-end align-right">
                <button class="btn btn-secondary" @click="showSalesTable">View Table</button>
                &nbsp;
                <button class="btn btn-secondary" @click="downloadData">Download</button>
              </div>
              <div class="row p-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive table-responsive-sm mb-5" style="overflow:auto;">
                    <v-table id="myappsTable" :data="propertyTaxList" :currentPage.sync="currentPage" :pageSize="perPage"
                      @totalPagesChanged="totalRows = $event" class="table table-sm table-bordered table-striped">
                      <thead class="table-month-header-blue wrap-text" slot="head">
                        <v-th sortKey="zipCode">Zip<br> Code</v-th>
                        <v-th sortKey="state">State</v-th>
                        <v-th sortKey="country">County</v-th>
                        <v-th sortKey="city">City</v-th>
                        <v-th sortKey="stateSalesTax">State <br>Sales <br>Tax (%)</v-th>
                        <v-th sortKey="countrySalesTax">County<br> Sales<br> Tax (%)</v-th>
                        <v-th sortKey="citySalesTax">City<br> Sales<br> Tax (%)</v-th>
                        <v-th sortKey="localReg">Local/Regional<br> Sales<br> Tax (%)</v-th>
                        <v-th sortKey="personalPropertyTax">Personal<br> Property<br> Tax (%)</v-th>
                        <v-th sortKey="totalSalesTax">Total<br> Sales<br> Tax (%)</v-th>
                        <v-th sortKey="effectiveDate">Effective<br> Date</v-th>

                        <th>Action</th>
                      </thead>
                      <tbody slot="body" slot-scope="{ displayData }">
                        <tr v-for="property in displayData">

                          <td class="table-month-td">{{ property.zipCode }}</td>
                          <td class="table-month-td">{{ property.state }}</td>
                          <td class="table-month-td">{{ property.country }}</td>
                          <td class="table-month-td">{{ property.city }}</td>
                          <td class="table-month-td">{{ property.stateSalesTax }}</td>
                          <td class="table-month-td">{{ property.countrySalesTax }}</td>
                          <td class="table-month-td">{{ property.citySalesTax }}</td>
                          <td class="table-month-td">{{ property.localReg }}</td>
                          <td class="table-month-td">{{ property.personalPropertyTax }}</td>
                          <td class="table-month-td">{{ property.totalSalesTax }}</td>
                          <td class="table-month-td">{{
                            property.effectiveDate | moment("MM/DD/YYYY")
                          }}
                          </td>

                          <td class="table-month-td">
                            <a href="javascript:void(0)" title="Delete" @click="deleteData(property.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24"
                                viewBox="0 0 24 24">
                                <path
                                  d="M 10.806641 2 C 10.289641 2 9.7956875 2.2043125 9.4296875 2.5703125 L 9 3 L 4 3 A 1.0001 1.0001 0 1 0 4 5 L 20 5 A 1.0001 1.0001 0 1 0 20 3 L 15 3 L 14.570312 2.5703125 C 14.205312 2.2043125 13.710359 2 13.193359 2 L 10.806641 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z">
                                </path>
                              </svg>
                            </a>
                            <a @click="editData(property)" href="javascript:void(0)">
                              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24"
                                viewBox="0 0 24 24">
                                <path
                                  d="M 18.414062 2 C 18.158062 2 17.902031 2.0979687 17.707031 2.2929688 L 15.707031 4.2929688 L 14.292969 5.7070312 L 3 17 L 3 21 L 7 21 L 21.707031 6.2929688 C 22.098031 5.9019687 22.098031 5.2689063 21.707031 4.8789062 L 19.121094 2.2929688 C 18.926094 2.0979687 18.670063 2 18.414062 2 z M 18.414062 4.4140625 L 19.585938 5.5859375 L 18.292969 6.8789062 L 17.121094 5.7070312 L 18.414062 4.4140625 z M 15.707031 7.1210938 L 16.878906 8.2929688 L 6.171875 19 L 5 19 L 5 17.828125 L 15.707031 7.1210938 z">
                                </path>
                              </svg>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                    <template v-if="propertyTaxList.length == 0">
                      <center>
                        <span>
                          <b>No records found</b>
                          <br />
                        </span>
                      </center>
                    </template>
                    <!-- <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages"
                      :style="{ listStyle: none }" @pagechange="changePagination($event)" /> -->
                    <b-pagination v-if="totalRows > 0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                      aria-controls="myappsTable" @change="handleClick($event)"></b-pagination>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <nav class="navbar navbar-expand-lg bg-info text-white">
            <span>
              <b>Upload Sales & Property Tax CSV File</b>
            </span>
          </nav>
          <div class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            <div class="col-3 col-md-3 d-flex justify-content-lg-end align-items-center">
              <label class="col-form-label col-form-label-sm required">Upload Sales & Property Tax </label>
            </div>
            <div class="col-3 col-md-3 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <input type="file" @change="onPropertyFileSelected" accept=".xlsx" class="form-control input-sm"
                id="uploadfile" />
              <span class="alert-danger">{{ message }}</span>
            </div>
            <!-- <div class="col-6 col-md-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <button class="btn btn-secondary" @click="onPropertyUpload">Upload</button> -->

            <!-- <a href="/files/SaleTaxSampleFile.xlsx" class="btn btn-secondary" download>Download Sample File</a> -->
            <!-- </div> -->
            <div class="col-6 col-md-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <button class="btn btn-secondary" @click="onPropertyUpload">Upload</button>
              &nbsp; &nbsp;
              <a href="/files/SaleTaxSampleFile.xlsx" class="btn btn-secondary" download>Download Sample File</a>
            </div>
          </div>

          <nav class="navbar navbar-expand-lg bg-info text-white mt-4">
            <span>
              <b>Upload State Permission CSV File</b>
            </span>
          </nav>
          <div class="row row-cols-lg-12 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mb-4">
            <div class="col-3 col-md-3 d-flex justify-content-lg-end align-items-center">
              <label class="col-form-label col-form-label-sm required">Upload State Permission </label>
            </div>
            <div class="col-3 col-md-3 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <input type="file" @change="onStatePermissionFileSelected" accept=".xlsx" class="form-control input-sm"
                id="uploadStatePermisnfile" />
              <span class="alert-danger">{{ message }}</span>
            </div>
            <div class="col-6 col-md-6 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <button class="btn btn-secondary" @click="onStatePermissionUpload">Upload</button>
              &nbsp; &nbsp;
              <button class="btn btn-secondary" @click="downloadStatePermissionData">Download State Permisison File</button>
            </div>
          </div>

          <!-- <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
            <div class="col-12 col=md-12 d-flex justify-content-lg-end align-items-center">
              <label class="col-form-label col-form-label-sm required">Upload Permitted States </label>
            </div>
            <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <input type="file" @change="onPropertyFileSelected" accept=".xlsx" class="form-control input-sm"
                id="uploadfile" />
              <span class="alert-danger">{{ permittedMessage }}</span>
            </div>
            <div
              class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 d-none d-sm-block d-md-none">
            </div>
            <div class="col justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <button class="btn btn-secondary" @click="onPermittedStateUpload">Upload</button>

            </div>
          </div> -->

          <div id="myModal" class="modal">
            <!-- Modal content -->
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
            <div>
              <p style="margin-left:500px; margin-top:2px">please wait uploading the data....</p>
            </div>
          </div>

          <div id="statePermisnModal" class="modal">
            <!-- Modal content -->
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
            <div class="loader">
              <div class="cogs">
                <div class="cog cog0">
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </div>
              </div>
            </div>
            <div>
              <p style="margin-left:500px; margin-top:2px">please wait uploading state permission data....</p>
            </div>
          </div>

        </div>

        <bottom-footer></bottom-footer>
      </div>
    </div>
    <viewSalesTable v-if="showViewSalesTable" @closeViewTableModal="closeViewTableModal"
      :viewTableSearchData="viewTableSearchData" :totalRows="totalRows" :perPage="perPage" :isSearch="isSearch"></viewSalesTable>
    <editSalesTax v-if="editSalesPropertyTax" @closeEditSalesModal="closeEditSalesModal" :editSalesData="editSalesData">
    </editSalesTax>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import moment from 'moment'
import viewSalesTable from './view/ViewSalesTable.vue'
import editSalesTax from './edit/EditSalesProperty.vue'
import httpcommon from '../../js/http-common.js'

export default {
  components: { MainMenu, TopHeader, BottomFooter, viewSalesTable, editSalesTax },
  name: 'salesPropertyTax',
  props: [],
  data () {
    return {
      editSalesData: '',
      showViewSalesTable: false,
      editSalesPropertyTax: false,
      propertyTaxList: [],
      propertyTax: this.propertyTaxData(),
      currentPage: 1,
      perPage: 10,
      selectedProertyFile: '',
      selectedStatePermissionFile: '',
      message: '',
      permittedMessage: '',
      isSearch: false,
      totalRows: 0,
      viewTableSearchData: []
    }
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.fetchdata()
  },
  methods: {

    success (message) {
      this.$toasted.success(message).goAway(2000)
    },
    error (message) {
      this.$toasted.error(message).goAway(2000)
    },

    handleClick (event) {
      this.currentPage = event
      this.fetchdata()
    },

    fetchdata: function () {
      let url = `/salesPropertyTax/getAllSalesTax?page=${this.currentPage}&size=${this.perPage}`
      httpcommon
        .get(url)
        .then(response => {
          if (response.status == 200) {
            this.propertyTaxList = response.data.content
            this.totalRows = response.data.totalCount
          }
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    propertyTaxData () {
      return {
        zipcode: ''
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var txt1 = elmnt1.offsetHeight
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    onSubmit () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.isSearch = true
          let zipcode = this.propertyTax.zipcode
          httpcommon
            .get('/salesPropertyTax/getSalesTaxByZipCode?zipcode=' + zipcode)
            .then(response => {
              if (response.status == 200) {
                this.propertyTaxList = response.data
                this.viewTableSearchData = response.data
                this.totalRows = response.data.length
              }
            })
            .catch(e => {
              this.errors.push(e)
            })
        }
      })
    },
    isNumber: function (evt) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    onPropertyFileSelected (event) {
      this.selectedProertyFile = event.target.files[0]
      // console.log(event)
    },

    onStatePermissionFileSelected (event) {
      this.selectedStatePermissionFile = event.target.files[0]
      // console.log(event)
    },

    onPropertyUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadfile').value != '') {
        this.message = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('file', this.selectedProertyFile, this.selectedProertyFile.name)

        httpcommon
          .post('/salesPropertyTax/upload', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            // console.log(response)
            if (response) {
              if (this.isSearch) {
                this.onSubmit()
              } else {
                this.fetchdata()
              }
            }
            this.success(response.data)
            document.getElementById('uploadfile').value = null
          })
          .catch(e => {
            // console.log('Error in save data: ' + e)
            this.error('Internal Server Error')
            if (e.message === 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: collateralCSVFile!'
              document.getElementById('uploadfile').value = null
            } else if (e.message === 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadfile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.message = 'choose a excel file'
        this.uploadingMessage = ''
      }
    },

    onStatePermissionUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadStatePermisnfile').value != '') {
        this.message = ''
        var modal = document.getElementById('statePermisnModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('file', this.selectedStatePermissionFile, this.selectedStatePermissionFile.name)

        httpcommon
          .post('/salesPropertyTax/upload/permissionfile', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            // console.log(response)
            if (response) {
              if (this.isSearch) {
                this.onSubmit()
              } else {
                this.fetchdata()
              }
            }
            this.success(response.data)
            document.getElementById('uploadStatePermisnfile').value = null
          })
          .catch(e => {
            // console.log('Error in save data: ' + e)
            this.error('Internal Server Error')
            if (e.message == 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: State Permission File!'
              document.getElementById('uploadStatePermisnfile').value = null
            } else if (e.message == 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadStatePermisnfile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.message = 'choose a excel file'
        this.uploadingMessage = ''
      }
    },

    onPermittedStateUpload () {
      this.uploadingMessage = ''
      if (document.getElementById('uploadfile').value != '') {
        this.permittedMessage = ''
        var modal = document.getElementById('myModal')
        modal.style.display = 'block'
        const fd = new FormData()
        fd.append('file', this.selectedProertyFile, this.selectedProertyFile.name)

        collateralprice
          .post('/uploadPurchasePrice', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(response => {
            modal.style.display = 'none'
            // console.log(response)
            document.getElementById('uploadfile').value = null
          })
          .catch(e => {
            console.log('Error in save data: ' + e)
            if (e.message === 'Request failed with status code 417') {
              this.uploadingMessage =
                'Could not upload the file: collateralCSVFile!'
              document.getElementById('uploadfile').value = null
            } else if (e.message === 'Request failed with status code 400') {
              this.uploadingMessage = 'Please upload a csv file!'
              document.getElementById('uploadfile').value = null
            } else {
              this.uploadingMessage = ''
            }
            this.failure = true
            modal.style.display = 'none'
          })
      } else {
        this.permittedMessage = 'choose a excel file'
        this.uploadingMessage = ''
      }
    },
    changePagination (evt) {
      console.log(evt)
    },
    showSalesTable () {
      this.showViewSalesTable = true
    },

    editData (data) {
      this.editSalesData = data
      this.editSalesPropertyTax = true
    },
    closeViewTableModal () {
      this.closepopup()
    },

    closepopup () {
      this.showViewSalesTable = false
    },

    closeEditSalesModal () {
      this.closeEditPopup()
    },

    closeEditPopup () {
      this.editSalesPropertyTax = false
      if (this.isSearch) {
        this.onSubmit()
      } else {
        this.fetchdata()
      }
      this.success('Data updated successfully')
    },

    onReset () {
      this.isSearch = false
      this.propertyTax.zipcode = ''
      this.fetchdata()
    },

    deleteData (id) {
      // console.log(this.currentPage)
      if (confirm('Do you really want to delete?')) {
        httpcommon.delete('/salesPropertyTax/delete?id=' + id).then(res => {
          if (res) {
            if (this.isSearch) {
              this.onSubmit()
            } else {
              this.fetchdata()
            }
            this.success('Data deleted successfully')
          }
        })
      }
    },
    downloadData () {
      httpcommon.get('/salesPropertyTax/downloadAllSalesTax', {
        headers: {
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.download = 'SalesPropertyTax.xlsx'
          link.click()
          this.success('Data download successfully')
        }
      }, () => {
        this.error('File upload in progress, please wait...')
      })
    },

    downloadStatePermissionData () {
      httpcommon.get('/salesPropertyTax/download/permissionfile', {
        headers: {
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const url = URL.createObjectURL(new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.download = 'StatePermission.xlsx'
          link.click()
          this.success('State permission data download successfully')
        }
      }, () => {
        this.error('File upload in progress, please wait...')
      })
    }

  },
  computed: {}
}
</script>
<style>
.align-right {
  text-align: right;
}
</style>